
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gfi",
      function () {
        return require("private-next-pages/gfi/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gfi"])
      });
    }
  